// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".Filters{display:flex;justify-content:flex-end;width:100%}.Filters>*{margin-right:1rem}\n", "",{"version":3,"sources":["/opt/src/app/javascript/components/Filters.scss"],"names":[],"mappings":"AAAA,SACE,YAAa,CACb,wBAAyB,CACzB,UAAW,CAHb,WAMI,iBAAkB","file":"Filters.scss","sourcesContent":[".Filters {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n\n  & > * {\n    margin-right: 1rem;\n  }\n}\n"]}]);
// Exports
module.exports = exports;
